@file:OptIn(InternalResourceApi::class)

package banko.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/banko.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_519_635)
public val Res.string.stats_bot: StringResource by lazy {
      StringResource("string:stats_bot", "stats_bot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18626, 21),
      ))
    }

@delegate:ResourceContentHash(852_700_121)
public val Res.string.stats_busted: StringResource by lazy {
      StringResource("string:stats_busted", "stats_busted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18683, 28),
      ))
    }

@delegate:ResourceContentHash(-563_170_324)
public val Res.string.stats_busted_value: StringResource by lazy {
      StringResource("string:stats_busted_value", "stats_busted_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18648, 34),
      ))
    }

@delegate:ResourceContentHash(1_657_965)
public val Res.string.stats_dash: StringResource by lazy {
      StringResource("string:stats_dash", "stats_dash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18712, 22),
      ))
    }

@delegate:ResourceContentHash(-33_682_615)
public val Res.string.stats_doubles: StringResource by lazy {
      StringResource("string:stats_doubles", "stats_doubles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18735, 33),
      ))
    }

@delegate:ResourceContentHash(200_973_146)
public val Res.string.stats_history_incomplete: StringResource by lazy {
      StringResource("string:stats_history_incomplete", "stats_history_incomplete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18769, 212),
      ))
    }

@delegate:ResourceContentHash(1_516_337_365)
public val Res.string.stats_leader: StringResource by lazy {
      StringResource("string:stats_leader", "stats_leader", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18982, 28),
      ))
    }

@delegate:ResourceContentHash(897_773_069)
public val Res.string.stats_nerve: StringResource by lazy {
      StringResource("string:stats_nerve", "stats_nerve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19053, 27),
      ))
    }

@delegate:ResourceContentHash(-1_757_756_772)
public val Res.string.stats_nerve_value: StringResource by lazy {
      StringResource("string:stats_nerve_value", "stats_nerve_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19011, 41),
      ))
    }

@delegate:ResourceContentHash(728_050_796)
public val Res.string.stats_no_rounds_yet: StringResource by lazy {
      StringResource("string:stats_no_rounds_yet", "stats_no_rounds_yet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19081, 95),
      ))
    }

@delegate:ResourceContentHash(-264_499_460)
public val Res.string.stats_points_behind: StringResource by lazy {
      StringResource("string:stats_points_behind", "stats_points_behind", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19177, 43),
      ))
    }

@delegate:ResourceContentHash(1_804_701_512)
public val Res.string.stats_rolls: StringResource by lazy {
      StringResource("string:stats_rolls", "stats_rolls", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19221, 27),
      ))
    }

@delegate:ResourceContentHash(1_105_620_776)
public val Res.string.stats_round_label: StringResource by lazy {
      StringResource("string:stats_round_label", "stats_round_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19249, 41),
      ))
    }

@delegate:ResourceContentHash(-939_795_200)
public val Res.string.stats_round_short: StringResource by lazy {
      StringResource("string:stats_round_short", "stats_round_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19291, 33),
      ))
    }

@delegate:ResourceContentHash(737_457_562)
public val Res.string.stats_score_race_hint: StringResource by lazy {
      StringResource("string:stats_score_race_hint", "stats_score_race_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19325, 93),
      ))
    }

@delegate:ResourceContentHash(-1_720_235_253)
public val Res.string.stats_score_race_start: StringResource by lazy {
      StringResource("string:stats_score_race_start", "stats_score_race_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19419, 38),
      ))
    }

@delegate:ResourceContentHash(1_200_729_760)
public val Res.string.stats_section_awards: StringResource by lazy {
      StringResource("string:stats_section_awards", "stats_section_awards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19458, 44),
      ))
    }

@delegate:ResourceContentHash(1_843_560_012)
public val Res.string.stats_section_dice: StringResource by lazy {
      StringResource("string:stats_section_dice", "stats_section_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19503, 42),
      ))
    }

@delegate:ResourceContentHash(-660_380_007)
public val Res.string.stats_section_players: StringResource by lazy {
      StringResource("string:stats_section_players", "stats_section_players", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19546, 53),
      ))
    }

@delegate:ResourceContentHash(955_316_219)
public val Res.string.stats_section_rounds: StringResource by lazy {
      StringResource("string:stats_section_rounds", "stats_section_rounds", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19600, 48),
      ))
    }

@delegate:ResourceContentHash(-2_033_266_906)
public val Res.string.stats_section_score_race: StringResource by lazy {
      StringResource("string:stats_section_score_race", "stats_section_score_race", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19649, 48),
      ))
    }

@delegate:ResourceContentHash(-1_889_591_586)
public val Res.string.stats_section_standings: StringResource by lazy {
      StringResource("string:stats_section_standings", "stats_section_standings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19698, 43),
      ))
    }

@delegate:ResourceContentHash(2_375_157)
public val Res.string.stats_sevens: StringResource by lazy {
      StringResource("string:stats_sevens", "stats_sevens", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19742, 24),
      ))
    }

@delegate:ResourceContentHash(2_677_240)
public val Res.string.stats_you: StringResource by lazy {
      StringResource("string:stats_you", "stats_you", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19767, 21),
      ))
    }

@delegate:ResourceContentHash(-1_053_538_291)
public val Res.string.store_headline: StringResource by lazy {
      StringResource("string:store_headline", "store_headline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19789, 46),
      ))
    }

@delegate:ResourceContentHash(62_186_788)
public val Res.string.store_loading_purchases: StringResource by lazy {
      StringResource("string:store_loading_purchases", "store_loading_purchases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19836, 67),
      ))
    }

@delegate:ResourceContentHash(-1_356_832_193)
public val Res.string.store_no_purchase_options: StringResource by lazy {
      StringResource("string:store_no_purchase_options", "store_no_purchase_options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19904, 85),
      ))
    }

@delegate:ResourceContentHash(-1_330_788_948)
public val Res.string.store_plus_headline: StringResource by lazy {
      StringResource("string:store_plus_headline", "store_plus_headline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19990, 51),
      ))
    }

@delegate:ResourceContentHash(628_989_388)
public val Res.string.store_row_subtitle: StringResource by lazy {
      StringResource("string:store_row_subtitle", "store_row_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20102, 78),
      ))
    }

@delegate:ResourceContentHash(2_015_751_399)
public val Res.string.store_row_subtitle_plus: StringResource by lazy {
      StringResource("string:store_row_subtitle_plus", "store_row_subtitle_plus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20042, 59),
      ))
    }

@delegate:ResourceContentHash(-1_053_538_291)
public val Res.string.store_row_title: StringResource by lazy {
      StringResource("string:store_row_title", "store_row_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20181, 47),
      ))
    }

@delegate:ResourceContentHash(1_978_903_786)
public val Res.string.store_title: StringResource by lazy {
      StringResource("string:store_title", "store_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20229, 35),
      ))
    }

@delegate:ResourceContentHash(-1_285_568_987)
public val Res.string.style_balanced: StringResource by lazy {
      StringResource("string:style_balanced", "style_balanced", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20265, 34),
      ))
    }

@delegate:ResourceContentHash(-1_344_839_139)
public val Res.string.style_cautious: StringResource by lazy {
      StringResource("string:style_cautious", "style_cautious", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20300, 34),
      ))
    }

@delegate:ResourceContentHash(-1_271_380_849)
public val Res.string.style_daredevil: StringResource by lazy {
      StringResource("string:style_daredevil", "style_daredevil", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20335, 35),
      ))
    }

@delegate:ResourceContentHash(1_303_812_526)
public val Res.string.subscription_manage_hint: StringResource by lazy {
      StringResource("string:subscription_manage_hint", "subscription_manage_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20371, 112),
      ))
    }

@delegate:ResourceContentHash(1_206_600_996)
public val Res.string.switch_to_yearly: StringResource by lazy {
      StringResource("string:switch_to_yearly", "switch_to_yearly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20718, 48),
      ))
    }

@delegate:ResourceContentHash(-1_746_033_828)
public val Res.string.switch_to_yearly_hint: StringResource by lazy {
      StringResource("string:switch_to_yearly_hint", "switch_to_yearly_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20484, 157),
      ))
    }

@delegate:ResourceContentHash(1_585_702_482)
public val Res.string.switch_to_yearly_with_price: StringResource by lazy {
      StringResource("string:switch_to_yearly_with_price", "switch_to_yearly_with_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20642, 75),
      ))
    }

@delegate:ResourceContentHash(-417_115_918)
public val Res.string.table_recap: StringResource by lazy {
      StringResource("string:table_recap", "table_recap", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20767, 35),
      ))
    }

@delegate:ResourceContentHash(1_295_777_575)
public val Res.string.table_title_pass_and_play: StringResource by lazy {
      StringResource("string:table_title_pass_and_play", "table_title_pass_and_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20803, 49),
      ))
    }

@delegate:ResourceContentHash(1_239_916_507)
public val Res.string.table_title_practice: StringResource by lazy {
      StringResource("string:table_title_practice", "table_title_practice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20853, 48),
      ))
    }

@delegate:ResourceContentHash(1_424_780_482)
public val Res.string.table_totals: StringResource by lazy {
      StringResource("string:table_totals", "table_totals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20902, 100),
      ))
    }

@delegate:ResourceContentHash(1_214_722_082)
public val Res.string.terms_of_use: StringResource by lazy {
      StringResource("string:terms_of_use", "terms_of_use", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21003, 36),
      ))
    }

@delegate:ResourceContentHash(-46_438_435)
public val Res.string.tier_best_value: StringResource by lazy {
      StringResource("string:tier_best_value", "tier_best_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21040, 39),
      ))
    }

@delegate:ResourceContentHash(1_358_961_977)
public val Res.string.tier_owned: StringResource by lazy {
      StringResource("string:tier_owned", "tier_owned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21080, 26),
      ))
    }

@delegate:ResourceContentHash(1_297_460_515)
public val Res.string.tier_plus_monthly_title: StringResource by lazy {
      StringResource("string:tier_plus_monthly_title", "tier_plus_monthly_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21107, 63),
      ))
    }

@delegate:ResourceContentHash(44_702_339)
public val Res.string.tier_plus_yearly_title: StringResource by lazy {
      StringResource("string:tier_plus_yearly_title", "tier_plus_yearly_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21171, 58),
      ))
    }

@delegate:ResourceContentHash(-2_067_352_498)
public val Res.string.tier_remove_ads_title: StringResource by lazy {
      StringResource("string:tier_remove_ads_title", "tier_remove_ads_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21230, 45),
      ))
    }

@delegate:ResourceContentHash(-824_896_494)
public val Res.string.unmute_reactions: StringResource by lazy {
      StringResource("string:unmute_reactions", "unmute_reactions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21276, 56),
      ))
    }

@delegate:ResourceContentHash(-1_955_141_916)
public val Res.string.update_required_button: StringResource by lazy {
      StringResource("string:update_required_button", "update_required_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21333, 38),
      ))
    }

@delegate:ResourceContentHash(-401_750_093)
public val Res.string.update_required_message: StringResource by lazy {
      StringResource("string:update_required_message", "update_required_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21372, 159),
      ))
    }

@delegate:ResourceContentHash(1_600_524_755)
public val Res.string.update_required_title: StringResource by lazy {
      StringResource("string:update_required_title", "update_required_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21532, 49),
      ))
    }

@delegate:ResourceContentHash(-1_845_293_742)
public val Res.string.use_system_colors: StringResource by lazy {
      StringResource("string:use_system_colors", "use_system_colors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21582, 49),
      ))
    }

@delegate:ResourceContentHash(-1_175_656_536)
public val Res.string.waiting_for_host: StringResource by lazy {
      StringResource("string:waiting_for_host", "waiting_for_host", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21711, 64),
      ))
    }

@delegate:ResourceContentHash(-1_175_656_536)
public val Res.string.waiting_for_host_to_start_game: StringResource by lazy {
      StringResource("string:waiting_for_host_to_start_game", "waiting_for_host_to_start_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21632, 78),
      ))
    }

@delegate:ResourceContentHash(1_131_801_144)
public val Res.string.who_can_join: StringResource by lazy {
      StringResource("string:who_can_join", "who_can_join", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21776, 40),
      ))
    }

@delegate:ResourceContentHash(1_369_475_046)
public val Res.string.winner_format: StringResource by lazy {
      StringResource("string:winner_format", "winner_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21817, 37),
      ))
    }

@delegate:ResourceContentHash(440_295_849)
public val Res.string.winner_label: StringResource by lazy {
      StringResource("string:winner_label", "winner_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21855, 32),
      ))
    }

@delegate:ResourceContentHash(1_371_479_611)
public val Res.string.your_dice: StringResource by lazy {
      StringResource("string:your_dice", "your_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21888, 29),
      ))
    }

@delegate:ResourceContentHash(-1_970_019_823)
public val Res.string.your_stats: StringResource by lazy {
      StringResource("string:your_stats", "your_stats", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22090, 34),
      ))
    }

@delegate:ResourceContentHash(-643_710_960)
public val Res.string.your_stats_row_empty: StringResource by lazy {
      StringResource("string:your_stats_row_empty", "your_stats_row_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21918, 84),
      ))
    }

@delegate:ResourceContentHash(-2_050_430_197)
public val Res.string.your_stats_row_summary: StringResource by lazy {
      StringResource("string:your_stats_row_summary", "your_stats_row_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22003, 86),
      ))
    }

@delegate:ResourceContentHash(-956_907_344)
public val Res.string.your_turn: StringResource by lazy {
      StringResource("string:your_turn", "your_turn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22125, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("stats_bot", Res.string.stats_bot)
  map.put("stats_busted", Res.string.stats_busted)
  map.put("stats_busted_value", Res.string.stats_busted_value)
  map.put("stats_dash", Res.string.stats_dash)
  map.put("stats_doubles", Res.string.stats_doubles)
  map.put("stats_history_incomplete", Res.string.stats_history_incomplete)
  map.put("stats_leader", Res.string.stats_leader)
  map.put("stats_nerve", Res.string.stats_nerve)
  map.put("stats_nerve_value", Res.string.stats_nerve_value)
  map.put("stats_no_rounds_yet", Res.string.stats_no_rounds_yet)
  map.put("stats_points_behind", Res.string.stats_points_behind)
  map.put("stats_rolls", Res.string.stats_rolls)
  map.put("stats_round_label", Res.string.stats_round_label)
  map.put("stats_round_short", Res.string.stats_round_short)
  map.put("stats_score_race_hint", Res.string.stats_score_race_hint)
  map.put("stats_score_race_start", Res.string.stats_score_race_start)
  map.put("stats_section_awards", Res.string.stats_section_awards)
  map.put("stats_section_dice", Res.string.stats_section_dice)
  map.put("stats_section_players", Res.string.stats_section_players)
  map.put("stats_section_rounds", Res.string.stats_section_rounds)
  map.put("stats_section_score_race", Res.string.stats_section_score_race)
  map.put("stats_section_standings", Res.string.stats_section_standings)
  map.put("stats_sevens", Res.string.stats_sevens)
  map.put("stats_you", Res.string.stats_you)
  map.put("store_headline", Res.string.store_headline)
  map.put("store_loading_purchases", Res.string.store_loading_purchases)
  map.put("store_no_purchase_options", Res.string.store_no_purchase_options)
  map.put("store_plus_headline", Res.string.store_plus_headline)
  map.put("store_row_subtitle", Res.string.store_row_subtitle)
  map.put("store_row_subtitle_plus", Res.string.store_row_subtitle_plus)
  map.put("store_row_title", Res.string.store_row_title)
  map.put("store_title", Res.string.store_title)
  map.put("style_balanced", Res.string.style_balanced)
  map.put("style_cautious", Res.string.style_cautious)
  map.put("style_daredevil", Res.string.style_daredevil)
  map.put("subscription_manage_hint", Res.string.subscription_manage_hint)
  map.put("switch_to_yearly", Res.string.switch_to_yearly)
  map.put("switch_to_yearly_hint", Res.string.switch_to_yearly_hint)
  map.put("switch_to_yearly_with_price", Res.string.switch_to_yearly_with_price)
  map.put("table_recap", Res.string.table_recap)
  map.put("table_title_pass_and_play", Res.string.table_title_pass_and_play)
  map.put("table_title_practice", Res.string.table_title_practice)
  map.put("table_totals", Res.string.table_totals)
  map.put("terms_of_use", Res.string.terms_of_use)
  map.put("tier_best_value", Res.string.tier_best_value)
  map.put("tier_owned", Res.string.tier_owned)
  map.put("tier_plus_monthly_title", Res.string.tier_plus_monthly_title)
  map.put("tier_plus_yearly_title", Res.string.tier_plus_yearly_title)
  map.put("tier_remove_ads_title", Res.string.tier_remove_ads_title)
  map.put("unmute_reactions", Res.string.unmute_reactions)
  map.put("update_required_button", Res.string.update_required_button)
  map.put("update_required_message", Res.string.update_required_message)
  map.put("update_required_title", Res.string.update_required_title)
  map.put("use_system_colors", Res.string.use_system_colors)
  map.put("waiting_for_host", Res.string.waiting_for_host)
  map.put("waiting_for_host_to_start_game", Res.string.waiting_for_host_to_start_game)
  map.put("who_can_join", Res.string.who_can_join)
  map.put("winner_format", Res.string.winner_format)
  map.put("winner_label", Res.string.winner_label)
  map.put("your_dice", Res.string.your_dice)
  map.put("your_stats", Res.string.your_stats)
  map.put("your_stats_row_empty", Res.string.your_stats_row_empty)
  map.put("your_stats_row_summary", Res.string.your_stats_row_summary)
  map.put("your_turn", Res.string.your_turn)
}
